import PropTypes from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';

const prefix = 'CASHIER';
const createAction = createPrefixedActionFactory(prefix);

export const setPaymentMethods = createAction({
  type: 'SET_PAYMENT_METHODS',
  propTypes: {
    paymentMethods: PropTypes.array,
  },
});

export const setPaymentMetadata = createAction({
  type: 'SET_PAYMENT_METADATA',
  propTypes: {
    paymentMetadata: PropTypes.object,
  },
});
